
(function () {
  
  var MOBILE_CARD_CAP = 3; // Author schema max 3; extras removed from DOM — sync Confluence guide

  
  var PANEL_SLOTS = 10; // Keep in sync with snippets/header-new-tier2-slot-budget.liquid
  var PANEL_ROW_COLS = 5;

  function cssEscape(value) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  
  function retrackPanelCols(panel) { // Featured panels: redo Liquid slot/column caps; empty tracks still consume gap
    var cols = panel && panel.querySelector('.header-new__panel-cols');
    if (!cols) return;
    
    var media = cols.querySelector('.header-new__panel-media');
    var cardSlots = media ? slotsOf(media) : 0;
    var textCap = Math.max(1, PANEL_SLOTS - cardSlots);
    var spent = 0;
    var tracks = cardSlots;
    Array.prototype.forEach.call(cols.children, function (child) {
      if (child === media) return;
      var slots = slotsOf(child);
      spent += slots;
      if (spent > textCap) {
        child.classList.add('header-new__panel-col--over-capacity');
        return;
      }
      child.classList.remove('header-new__panel-col--over-capacity');
      tracks += slots;
    });
    cols.style.setProperty('--cols', Math.max(1, Math.min(tracks, PANEL_ROW_COLS)));
  }

  
  function slotsOf(el) { // Missing --slots defaults to 1 (Liquid + CSS var(--slots, 1))
    var slots = parseInt(el.style.getPropertyValue('--slots'), 10);
    return slots > 0 ? slots : 1;
  }

  
  function applySlotOverrides(panel) {
    if (!panel) return;
    
    var bucket = panel.querySelector('[data-slot-overrides]');
    var overrides = bucket ? bucket.querySelectorAll('[data-slot-override]') : [];
    var mediaType = panel.getAttribute('data-media-type') || '';

    Array.prototype.forEach.call(overrides, function (override, idx) {
      if (idx >= 3) return; 

      var slotIdx = idx + 1;
      var card = panel.querySelector(
        '[data-slot-card][data-slot-card-index="' + slotIdx + '"]'
      );
      if (!card) return;

      
      var isPlaceholder = card.hasAttribute('data-slot-card-placeholder');

      var imgUrl = override.getAttribute('data-image-url') || '';
      var imgAlt = override.getAttribute('data-image-alt') || '';
      var link = override.getAttribute('data-link') || '';
      
      var caption = override.getAttribute('data-caption') || '';

      
      if (isPlaceholder && !imgUrl) return;

      if (imgUrl) {
        var cardImg = card.querySelector('img');
        if (!cardImg && isPlaceholder) {
          
          cardImg = document.createElement('img');
          cardImg.setAttribute('width', '180');
          cardImg.setAttribute('height', '180');
          cardImg.setAttribute('loading', 'lazy');
          var imageWrap = card.querySelector('.header-new__panel-media-image');
          if (imageWrap) imageWrap.insertBefore(cardImg, imageWrap.firstChild);
        }
        if (cardImg) {
          
          cardImg.removeAttribute('srcset');
          cardImg.removeAttribute('sizes');
          cardImg.setAttribute('src', imgUrl);
          
          cardImg.setAttribute('alt', imgAlt);
        }
      }

      
      if (mediaType === 'featured_products' || mediaType === 'featured_collections') {
        if (link) {
          if (card.tagName === 'A') {
            card.setAttribute('href', link);
          } else {
            var cardA = card.querySelector('a');
            if (cardA) cardA.setAttribute('href', link);
          }
        }
        if (caption) {
          var captionEl = card.querySelector('[data-slot-card-caption]');
          if (!captionEl) {
            
            captionEl = document.createElement('span');
            captionEl.className = 'header-new__panel-media-caption';
            captionEl.setAttribute('data-slot-card-caption', '');
            card.appendChild(captionEl);
          }
          captionEl.textContent = caption;
        } else if (link) {
          
          var staleCaptionEl = card.querySelector('[data-slot-card-caption]');
          if (staleCaptionEl && staleCaptionEl.parentNode) {
            staleCaptionEl.parentNode.removeChild(staleCaptionEl);
          }
        }
      }

      
      if (isPlaceholder && card.querySelector('img')) {
        card.removeAttribute('data-slot-card-placeholder');
        card.removeAttribute('hidden');
      }
    });

    
    var media = panel.querySelector('.header-new__panel-media');
    if (media) {
      var unfilled = media.querySelectorAll('[data-slot-card-placeholder]');
      Array.prototype.forEach.call(unfilled, function (placeholder) {
        placeholder.parentNode && placeholder.parentNode.removeChild(placeholder);
      });
      var kept = media.querySelectorAll('[data-slot-card]').length;
      if (!kept) {
        media.parentNode && media.parentNode.removeChild(media);
        panel.classList.remove('header-new__panel-body--with-media');
      } else {
        
        media.style.setProperty('--slots', kept);
      }
      retrackPanelCols(panel);
    }

    
    if (bucket) bucket.parentNode && bucket.parentNode.removeChild(bucket);
  }

  function wire(scopeEl) {
    var scope = scopeEl || document;
    var staging = scope.querySelector('[data-header-new-staging]');
    if (!staging) return;

    var cardSlot = scope.querySelector('[data-mobile-cards-slot]');
    if (cardSlot) {
      var cards = staging.querySelectorAll('[data-mobile-card]');
      
      if (cards.length) { // Only rebuild mobile slot when staging has fresh cards (not block:select)
        var prevCards = cardSlot.querySelectorAll('[data-mobile-card]');
        Array.prototype.forEach.call(prevCards, function (n) {
          n.parentNode && n.parentNode.removeChild(n);
        });
        
        var placedImageCards = 0;
        Array.prototype.forEach.call(cards, function (card) {
          var isPlaceholder = card.hasAttribute('data-mobile-card-placeholder');
          if (!isPlaceholder && placedImageCards >= MOBILE_CARD_CAP) {
            card.parentNode && card.parentNode.removeChild(card);
            return;
          }
          cardSlot.appendChild(card);
          if (!isPlaceholder) placedImageCards += 1;
        });
      }
    }

    var panels = staging.querySelectorAll('[data-submenu-panel]');
    
    if (panels.length === 0) return;

    
    var allDesktopSlots = scope.querySelectorAll('[data-desktop-slot]');
    Array.prototype.forEach.call(allDesktopSlots, function (slot) {
      slot.classList.remove('header-new__panel--mega');
      var li = slot.closest('.header-new__menu-item');
      if (li) li.classList.remove('header-new__menu-item--mega');
    });

    Array.prototype.forEach.call(panels, function (panel) {
      var label = panel.getAttribute('data-menu-label') || '';
      var escLabel = cssEscape(label);
      
      var mediaType = panel.getAttribute('data-media-type') || 'text';
      var isMega = mediaType !== 'text' && mediaType !== 'house'; // Mega from media_type; house stays compact

      var desktopSlot = scope.querySelector('[data-desktop-slot="' + escLabel + '"]');
      if (desktopSlot) {
        
        var prevDFallback = desktopSlot.querySelectorAll('[data-fallback]');
        Array.prototype.forEach.call(prevDFallback, function (n) {
          n.parentNode && n.parentNode.removeChild(n);
        });
        var prevD = desktopSlot.querySelector('[data-submenu-panel]');
        if (prevD) prevD.parentNode.removeChild(prevD);
        var cloneD = panel.cloneNode(true);
        cloneD.removeAttribute('hidden');
        desktopSlot.appendChild(cloneD);
        if (isMega) {
          desktopSlot.classList.add('header-new__panel--mega');
          var item = desktopSlot.closest('.header-new__menu-item');
          if (item) item.classList.add('header-new__menu-item--mega');
        }
        try { applySlotOverrides(cloneD); } catch (e) {
          if (window.console && console.warn) {
            console.warn('header-new slot override (desktop) failed:', e);
          }
        }
      }

      var mobileSlot = scope.querySelector('[data-mobile-slot="' + escLabel + '"]');
      if (mobileSlot) {
        var prevMFallback = mobileSlot.querySelectorAll('[data-fallback]');
        Array.prototype.forEach.call(prevMFallback, function (n) {
          n.parentNode && n.parentNode.removeChild(n);
        });
        var prevM = mobileSlot.querySelector('[data-submenu-panel]');
        if (prevM) prevM.parentNode.removeChild(prevM);
        var cloneM = panel.cloneNode(true);
        cloneM.removeAttribute('hidden');
        mobileSlot.appendChild(cloneM);
        try { applySlotOverrides(cloneM); } catch (e) {
          if (window.console && console.warn) {
            console.warn('header-new slot override (mobile) failed:', e);
          }
        }
      }

      
      panel.parentNode && panel.parentNode.removeChild(panel);
    });
  }

  
  function applyOverflow(scopeEl) { // Measure Tier 1 wrap with header-new--overflow off, one sync task
    var root = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;
    var grids = root.querySelectorAll('.header-new');
    var isDesktop = window.matchMedia('(min-width: 1280px)').matches;
    Array.prototype.forEach.call(grids, function (grid) {
      if (!isDesktop) { // Below 1280px CSS owns drawer; clear overflow class
        
        grid.classList.remove('header-new--overflow');
        return;
      }
      var menu = grid.querySelector('.header-new__inline-menu .header-new__menu');
      if (!menu) {
        grid.classList.remove('header-new--overflow');
        return;
      }
      grid.classList.remove('header-new--overflow');
      var items = menu.children;
      var wrapped = false;
      if (items.length > 1) {
        var firstTop = items[0].offsetTop;
        for (var i = 1; i < items.length; i++) {
          if (items[i].offsetTop - firstTop > 1) {
            wrapped = true;
            break;
          }
        }
      }
      if (wrapped) {
        grid.classList.add('header-new--overflow'); // CSS hide does not close open details
        
        var openInline = grid.querySelectorAll('.header-new__inline-menu .header-new__details[open]');
        Array.prototype.forEach.call(openInline, function (d) {
          d.open = false;
        });
      }
    });
    
    document.body.classList.toggle(
      'header-new-submenu-open',
      !!document.querySelector('.header-new__inline-menu .header-new__details[open]')
    );
  }

  var overflowRaf = null;
  function scheduleOverflow() {
    if (overflowRaf) cancelAnimationFrame(overflowRaf);
    overflowRaf = requestAnimationFrame(function () {
      overflowRaf = null;
      applyOverflow();
      
      repositionVisiblePanels();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); applyOverflow(); bindHover(); });
  } else {
    wire();
    applyOverflow();
    bindHover();
  }

  window.addEventListener('resize', scheduleOverflow);
  
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(function () { applyOverflow(); repositionVisiblePanels(); });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var t = evt.target;
    if (t && t.classList && t.classList.contains('section-header')) {
      wire(t);
      applyOverflow(t);
      bindHover(t);
    } else {
      wire();
      applyOverflow();
      bindHover();
    }
    
    repositionVisiblePanels();
  });

  document.addEventListener('shopify:block:select', function (evt) {
    
    var section = evt.target && evt.target.closest('.section-header');
    if (section) {
      wire(section);
      applyOverflow(section);
      bindHover(section);
      repositionVisiblePanels();
    }
  });

  
  document.addEventListener('click', function (evt) {
    
    var scrim = evt.target.closest('.header-new__scrim');
    if (scrim) {
      var wrap = scrim.closest('.header-new__wrapper');
      var openDrawer = wrap && wrap.querySelector('header-drawer details[open]');
      var scrimSummary = openDrawer && openDrawer.querySelector('summary');
      if (scrimSummary) scrimSummary.click();
      return;
    }

    var closeBtn = evt.target.closest('[data-header-new-drawer-close]');
    if (!closeBtn) return;
    var drawer = closeBtn.closest('header-drawer');
    var summary = drawer && drawer.querySelector('summary');
    if (summary) summary.click();
  });

  
  var desktopHover = window.matchMedia('(min-width: 1280px)');

  function setTier1Open(item, isOpen) { // Hover-open must sync summary aria-expanded
    var details = item.querySelector('.header-new__details');
    if (!details || details.open === isOpen) return;
    details.open = isOpen;
    
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function onHeaderMouseOver(evt) {
    if (!desktopHover.matches) return;
    var item = evt.target.closest('.header-new__menu-item--has-submenu');
    if (!item) return;
    
    var menu = item.closest('.header-new__menu') || document;
    var openDetails = menu.querySelectorAll('.header-new__menu-item--has-submenu .header-new__details[open]');
    Array.prototype.forEach.call(openDetails, function (details) {
      var openItem = details.closest('.header-new__menu-item--has-submenu');
      if (openItem && openItem !== item) setTier1Open(openItem, false);
    });
    setTier1Open(item, true); // positionCompactPanel now; toggle event is async after details.open
    
    positionCompactPanel(item.querySelector('.header-new__details'));
  }

  function onHeaderMouseOut(evt) {
    if (!desktopHover.matches) return;
    var item = evt.target.closest('.header-new__menu-item--has-submenu');
    if (!item) return;
    
    var to = evt.relatedTarget;
    if (to && item.contains(to)) return;
    
    if (item.contains(document.activeElement)) return; // Do not mouseout-close while :focus-within shows panel
    setTier1Open(item, false);
  }

  
  function bindHover(scopeEl) {
    var root = scopeEl && scopeEl.querySelectorAll ? scopeEl : document;
    var headers = root.querySelectorAll('.header-new');
    Array.prototype.forEach.call(headers, function (header) {
      if (header.dataset.hoverBound === 'true') return;
      header.dataset.hoverBound = 'true';
      header.addEventListener('mouseover', onHeaderMouseOver); // Per-header binding — document mouseover is too hot
      header.addEventListener('mouseout', onHeaderMouseOut);
    });
  }

  

  function positionCompactPanel(details) { // Flush right edge to documentElement.clientWidth, not innerWidth
    if (!details) return;
    var panel = details.querySelector('.header-new__panel');
    if (!panel) return;
    
    panel.style.transform = '';
    
    if (
      !desktopHover.matches ||
      panel.classList.contains('header-new__panel--mega') ||
      panel.offsetParent === null
    ) {
      return;
    }
    var rect = panel.getBoundingClientRect();
    
    var overflow = rect.right - document.documentElement.clientWidth;
    if (overflow > 0) {
      panel.style.transform = 'translateX(' + -Math.ceil(overflow) + 'px)';
    }
  }

  
  function repositionVisiblePanels() {
    var visible = document.querySelectorAll(
      '.header-new__inline-menu .header-new__details[open],' +
      '.header-new__inline-menu .header-new__details:focus-within'
    );
    Array.prototype.forEach.call(visible, positionCompactPanel);
  }

  
  document.addEventListener('focusin', function (evt) {
    if (!desktopHover.matches || !evt.target.closest) return;
    var item = evt.target.closest('.header-new__menu-item--has-submenu');
    if (!item) return;
    positionCompactPanel(item.querySelector('.header-new__details'));
  });

  
  document.addEventListener(
    'toggle', // toggle does not bubble; capture for body scrim + panel shift
    function (evt) {
      var details = evt.target;
      if (!details || !details.classList || !details.classList.contains('header-new__details')) return;
      
      positionCompactPanel(details);
      var anyOpen = document.querySelector('.header-new__inline-menu .header-new__details[open]');
      document.body.classList.toggle('header-new-submenu-open', !!anyOpen);
    },
    true
  );
})();
